module.exports = __webpack_public_path__ + "static/daudwbg-32e1aeebef4cf0a0b18f3ca4c4e92c21.png";